import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { useCallback, useState } from 'react';
const defaultState = {
    isProcessing: false
};
export const genericProcessingFailure = {
    message: COPY_GENERIC.CONTACT_SUPPORT,
    success: false
};
export function useProcessing() {
    const [state, setState] = useState(defaultState);
    const reset = useCallback(() => {
        setState(defaultState);
    }, []);
    const start = useCallback(() => {
        setState({ isProcessing: true });
    }, []);
    const stop = useCallback((result) => {
        setState({
            isProcessing: false,
            result
        });
    }, []);
    return {
        reset,
        start,
        state,
        stop
    };
}
